// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pageTitle_IAlrPCQh{font-size:20px;flex:1}.selected_Y5bXeHZ6{border:3px solid var(--color-selection)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageTitle": "pageTitle_IAlrPCQh",
	"selected": "selected_Y5bXeHZ6"
};
export default ___CSS_LOADER_EXPORT___;
